/* eslint-disable import/prefer-default-export */
/* eslint-disable react/jsx-indent-props */
/* eslint-disable react/prop-types */
/* eslint-disable no-trailing-spaces */
/* eslint-disable max-len */
/* eslint-disable guard-for-in */
/* eslint-disable no-restricted-syntax */
/* eslint-disable linebreak-style */
import http from "./httpService";
//const apiUrl = process.env.REACT_APP_API_URL;
const apiUrl = http.getApiURL();

export class DefaultService {
  constructor(controllerName) {
    this.controller = controllerName;
  }

  getAll = (
    menuItemCode,
    pageSize,
    pageNumber,
    orderBy,
    orderDirection,
    criteria
  ) => {
    const config = {
      headers: {
        MenuItemCode: menuItemCode,
      },
    };
   /* .NET CORE MVCC
     let url = `${apiUrl}/${this.controller}?pageSize=${pageSize}&pageNumber=${pageNumber}`;
   */
    let url = `${apiUrl}/${this.controller}/GetAll?pageSize=${pageSize}&pageNumber=${pageNumber}`;
    if (orderBy) url += `&orderBy=${orderBy}`;
    if (orderDirection) url += `&orderDirection=${orderDirection}`;
    if (criteria)
      url += `&criteria=${encodeURIComponent(JSON.stringify(criteria))}`;
    return http.get(url, config);
  };

  save = (menuItemCode, dataObject) => {
    const config = {
      headers: {
        MenuItemCode: menuItemCode,
      },
    };
    return http.post(
      `${apiUrl}/${this.controller}/Save`,
      { dataObj: JSON.stringify(dataObject) },
      config
    );
  };

  delete = (menuItemCode, dataObject) => {
    const config = {
      headers: {
        MenuItemCode: menuItemCode,
      },
    };
    return http.post(
      `${apiUrl}/${this.controller}/Delete`,
      { dataObj: JSON.stringify(dataObject) },
      config
    );
  };

  get(menuItemCode, id) {
    const config = {
      headers: {
        MenuItemCode: menuItemCode,
      },
    };
    return http.get(`${apiUrl}/${this.controller}/Get?Id=${id}`, config);
  }
}
